import { toast } from 'react-toastify';
import { USER_IP_SETTING } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';

export const fetchUserIPSettingTableAndFilterSchema = async (data = {}) => {
    try {
        const url = data?._Id
            ? `${USER_IP_SETTING.GET_USER_IP_SETTING_SCHEMA}/${data?._Id}`
            : `${USER_IP_SETTING.GET_USER_IP_SETTING_SCHEMA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const submitUserIPSettingFilterData = async (data = {}) => {
    try {
        const response = await POST(USER_IP_SETTING.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const updateUserIPSettingAllowed = async (data = {}) => {
    try {
        const id = data?.id ?? data?.Id;
        const url = USER_IP_SETTING.UPDATE_IS_ALLOWED(id);
        const response = await PUT(url, {
            id: String(id ?? ""),
            isAllowed: data?.isAllowed,
        });
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
